import React from 'react'
import { HiOutlineCreditCard, HiShoppingBag } from 'react-icons/hi'
import { HiArrowPathRoundedSquare, HiMiniShoppingBag } from 'react-icons/hi2'
import {Truck, RefreshCcw  , ShieldCheck } from 'lucide-react';



const FeaturesSection = () => {
  return (
    <section className="py-16 px-4 bg-white">
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-center ">
            {/* Feature 1 */}
            <div className="flex flex-col items-center py-2 border-black border-2 rounded-lg hover:bg-black hover:text-white">
                <div className="p-4 rounded-full">
                  
                  <Truck  size={50} strokeWidth={1.5} />
                  
                   
                </div>
                <h4 className="tracking-tighter md-2"> FREE SHIPPING</h4>
                <p className="text-gray-600 text-sm tracking-tighter ">T & C Apply</p>
            </div>

            {/* Feature 2 */}
            <div className="flex flex-col items-center py-4 border-black border-2 rounded-lg hover:bg-black hover:text-white">
                <div className="p-4 rounded-full ">
                  
                    <RefreshCcw  size={50} strokeWidth={1.5} />
                    
                </div>
                <h4 className="tracking-tighter md-2">Easy Return/Replacement</h4>
                <p className="text-gray-600 text-sm tracking-tighter ">Money Back Gurantee</p>
            </div>

            {/* Feature 3 */}
            <div className="flex py-4 flex-col items-center border-black border-2 rounded-lg cursor-pointer hover:bg-black hover:text-white">
                <div className="p-4  rounded-full  ">
                  
                    <ShieldCheck  size={50} strokeWidth={1.5} />
                </div>
                <h4 className="tracking-tighter md-2"> SECURE CHECKOUTS</h4>
                <p className="text-gray-600 text-sm tracking-tighter ">100% SECURED CHECKOUT PROCESS</p>
            </div>
        </div>
    </section>
  )
}


export default FeaturesSection;
